import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=6e2e0161&scoped=true&"
import script from "./ProfileForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileForm.vue?vue&type=style&index=0&id=6e2e0161&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e0161",
  null
  
)

export default component.exports